/* eslint-disable no-case-declarations */
import {
  EXPIRE_PACKAGE,
  GET_ADDONS_FAILURE,
  GET_ADDONS_REQUEST,
  GET_ADDONS_SUCCESS,
  GET_DEALS_FAILURE,
  GET_DEALS_REQUEST,
  GET_DEALS_SUCCESS,
  GET_ITEMEXPANDED_FAILURE,
  GET_ITEMEXPANDED_REQUEST,
  GET_ITEMEXPANDED_SUCCESS,
  GET_PACKAGES_FAILURE,
  GET_PACKAGES_REQUEST,
  GET_PACKAGES_SUCCESS
} from '../constants/ActionTypes';
import addOnKey from '../utils/addOnKey';
import dealKey from '../utils/dealKey';
import packageKey from '../utils/packageKey';

export default function inventory(
  state = {
    loading: false,
    loadingItemExpanded: 0,
    packages: {},
    addOns: {},
    deals: {},
    cacheBust: 0
  },
  action
) {
  let nextState = null;

  switch (action.type) {
    case GET_PACKAGES_SUCCESS:
      nextState = {
        ...state,
        packages: {
          ...state.packages,
          [packageKey(action.day)]: action.packages
        },
        error: null,
        loading: false
      };

      break;
    case GET_PACKAGES_REQUEST:
      nextState = {
        ...state,
        loading: true,
        error: null
      };

      break;
    case GET_PACKAGES_FAILURE:
      nextState = {
        ...state,
        loading: false,
        error: action.error,
        errors: action.errors
      };

      break;
    case GET_ADDONS_SUCCESS:
      if (action.pkg == null) {
        nextState = {
          ...state,
          error: null,
          loading: false
        };
      } else {
        nextState = {
          ...state,
          addOns: {
            ...state.addOns,
            [addOnKey(action.day, action.pkg)]: action.addOns
          },
          error: null,
          loading: false
        };
      }

      break;
    case GET_ADDONS_REQUEST:
      nextState = {
        ...state,
        loading: true,
        error: null
      };

      break;
    case GET_ADDONS_FAILURE:
      nextState = {
        ...state,
        loading: false,
        error: action.error,
        errors: action.errors
      };

      break;

    case GET_DEALS_SUCCESS:
      nextState = {
        ...state,
        deals: {
          ...state.deals,
          [dealKey(action.day)]: action.deals
        },
        error: null,
        loading: false
      };

      break;
    case GET_DEALS_REQUEST:
      nextState = {
        ...state,
        loading: true,
        error: null
      };

      break;
    case GET_DEALS_FAILURE:
      nextState = {
        ...state,
        loading: false,
        error: action.error,
        errors: action.errors
      };

      break;
    case EXPIRE_PACKAGE:
      nextState = {
        ...state,
        cacheBust: state.cacheBust + 1
      };
      break;
    case GET_ITEMEXPANDED_REQUEST:
      nextState = {
        ...state,
        loading: false,
        loadingItemExpandedInLineObj: {
          loading: true,
          item_id: action.pkg.item_id
        },
        loadingItemExpanded: state.loadingItemExpanded + 1,
        error: null
      };
      break;

    case GET_ITEMEXPANDED_FAILURE:
      nextState = {
        ...state,
        loading: false,
        loadingItemExpandedInLineObj: {
          loading: false,
          item_id: action.pkg.item_id
        },
        loadingItemExpanded: state.loadingItemExpanded - 1,
        error: action.error,
        errors: action.errors
      };
      break;
    case GET_ITEMEXPANDED_SUCCESS:
      {
        const _packageKey = packageKey(action.day);
        const _addOnKey = addOnKey(action.day, action.pkg);

        nextState = {
          ...state,
          loading: false,
          loadingItemExpanded: state.loadingItemExpanded - 1,
          error: null,
          loadingItemExpandedInLineObj: {
            loading: false,
            item_id: action.pkg.item_id
          },
          packages: {
            ...state.packages,
            [_packageKey]: state.packages[_packageKey].map(pkg => {
              if (action.items[pkg.item_id] != null) {
                return action.items[pkg.item_id];
              }

              return pkg;
            })
          },
          addOns: {
            ...state.addOns,
            ...(state.addOns[_addOnKey] && {
              [_addOnKey]: state.addOns[_addOnKey].map(pkg => {
                if (action.items[pkg.item_id] != null) {
                  return action.items[pkg.item_id];
                }

                return pkg;
              })
            })
          }
        };
      }
      break;
    default:
      break;
  }

  return nextState || state;
}
